import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';


class Home extends Component {

  render() {
    return (
      <div className="r_container">
        <div className="home">

          <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">INVITATION &amp; THE RATIONALE FOR LLM 2025:</h4>
            <div className="par">
              Large Language Models (LLMs) represent one of the most transformative advancements in Artificial Intelligence. These models - such as GPT, PaLM, LLaMA, and others - are trained on massive corpora of text data and have demonstrated an unprecedented ability to understand, generate, and manipulate human language. Their applications now span a wide range of domains including education, healthcare, law, scientific research, creative arts, customer service, and software development.
              <br /><br />
              LLMs have not only pushed the boundaries of natural language processing but have also raised new scientific, societal, and ethical questions. Issues such as model alignment, bias, misinformation, hallucinations, data privacy, intellectual property, and computational cost are now central to the discourse on responsible AI.
              <br /><br />
              Given the rapid progress and increasing deployment of LLMs across industries and institutions, there is a critical need for a focused venue to bring together researchers, developers, practitioners, and policymakers. This first major conference on Large Language Models aims to provide a platform to exchange ideas, share recent findings, explore use cases, and engage in discussions that shape the future of this powerful and evolving technology.
              <br /><br />
              The 2025 International Conference on Large Language Models, LLM 2025, invites high-quality paper submissions. LLM 2025 Conference aims to explore recent advances, challenges, applications, and ethical considerations surrounding the development and deployment of LLMs in diverse domains.
              <br /><br />
              Prospective authors and speakers are requested to refer to the links below for:
              <br /><br />
              <b>List of topics:</b><br />
              <a href="https://american-cse.org/LLM2025/topics" target="_blank" rel="noopener noreferrer">https://american-cse.org/LLM2025/topics</a>
              <br /><br />
              <b>Submission of Papers for Evaluation:</b><br />
              <a href="https://american-cse.org/LLM2025/paper_submission" target="_blank" rel="noopener noreferrer">https://american-cse.org/LLM2025/paper_submission</a>
              <br /><br />
              <b>Publisher:</b><br />
              <a href="https://american-cse.org/LLM2025/publisher" target="_blank" rel="noopener noreferrer">https://american-cse.org/LLM2025/publisher</a>
            </div>
          </div>
          

        </div>
      </div>
    );
  }
}

export default Home;